/**
 * Leaving the SPA with a real document navigation.
 *
 * Used after a successful sign-in. Safari/iCloud Keychain only offers to save
 * credentials when a form submission is followed by a document navigation, and
 * a client-side `navigate()` never unloads the page — so the "save this
 * password?" prompt never appears, and with nothing saved there is nothing to
 * autofill later either. Chrome is more forgiving (it watches for the form
 * being torn down after the XHR), which is why this only shows up in Safari.
 *
 * The cost is one extra bootstrap per login: the access token is memory-only,
 * so the reloaded app re-runs POST /auth/refresh + GET /auth/me. The refresh
 * cookie survives the navigation, so the session does too.
 */
export function hardRedirect(path: string) {
  window.location.replace(safeInternalPath(path));
}

/**
 * Clamps a redirect target to a path on this origin.
 *
 * react-router treats "//evil.com" as an ordinary path, but
 * `location.replace()` reads it as a protocol-relative URL and leaves the
 * site. Since the target originates from router state, this is the one place
 * that difference matters.
 */
export function safeInternalPath(path: string | null | undefined): string {
  if (!path || !path.startsWith("/") || path.startsWith("//")) return "/";
  return path;
}
